import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { AdminLoginComponent } from './admin-login.component';
import { AppConfigErrorPage } from './app-config/app-config-error.page';
import { AppInitializedGuard } from './app-initialized.guard';
import { AuthenticatedGuard, UnAuthenticatedGuard } from './auth/auth-user.guard';
import { CashBoxOpenedGuard } from './cashbox/cash-box-opened.guard';
import { LayoutPage } from './core/layout/layout.page';
import { NetworkErrorPage } from './core/network-error.page';
import { AppStateDataGuard } from './data/app-state-data.guard';
import { TerminalConfiguredGuard } from './terminal-configuration/terminal-configured.guard';

const webAppRoutes: Routes = [
  // Startup route where app configuration is received
  { path: 'config/:config', redirectTo: '/login' },
  { path: 'config-error', component: AppConfigErrorPage },
  { path: 'network-error', component: NetworkErrorPage },
  {
    path: 'admin-login',
    component: AdminLoginComponent,
  },

  // App routes
  {
    path: '',
    canActivateChild: [AppInitializedGuard],
    children: [
      // Authenticated routes
      {
        path: '',
        component: LayoutPage,
        canActivate: [AuthenticatedGuard, AppStateDataGuard],
        canActivateChild: [AuthenticatedGuard, AppStateDataGuard],
        children: [
          {
            path: '',
            canActivate: [CashBoxOpenedGuard],
            loadChildren: () => import('./products/products.module').then(m => m.ProductsModule),
          },
          {
            path: 'cart',
            canActivate: [CashBoxOpenedGuard],
            loadChildren: () => import('./cart/cart.module').then(m => m.CartModule),
          },
          {
            path: 'transaction-history',
            canActivate: [CashBoxOpenedGuard],
            loadChildren: () => import('./transaction-history/transaction-history.module')
              .then(m => m.TransactionHistoryModule),
          },
          {
            path: 'payment',
            canActivate: [CashBoxOpenedGuard],
            loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule),
          },
          {
            path: 'cash-box',
            loadChildren: () => import('./cashbox/cash-box.module').then(m => m.CashBoxModule),
          },
          {
            path: 'returns',
            loadChildren: () => import('./product-returns/product-returns.module').then(m => m.ProductReturnsModule),
          },
          {
            path: 'reservations',
            canActivate: [CashBoxOpenedGuard],
            loadChildren: () => import('./reservation/reservation.module').then(m => m.ReservationModule),
          },
        ],
      },
      // Un-authenticated routes
      {
        path: '',
        canActivateChild: [UnAuthenticatedGuard],
        children: [
          { path: 'login', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];

const nativeAppRoutes: Routes = [
  {
    path: 'terminal-configuration',
    loadChildren: () => import('./terminal-configuration/terminal-configuration.module')
      .then(m => m.TerminalConfigurationModule),
  },
  {
    path: '',
    canActivateChild: [TerminalConfiguredGuard],
    children: webAppRoutes,
  },
];

const routes: Routes = environment.runAsStandaloneApplication ? nativeAppRoutes : webAppRoutes;

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
